import React, { useId } from 'react';
import './Modal.css';

const Modal = ({ show, title, message, body, confirmText = 'OK', cancelText, onConfirm, onCancel, className, closeOnOverlayClick = false }) => {
  const titleId = useId();
  if (!show) return null;
  const handleOverlayClick = (e) => {
    if (!closeOnOverlayClick) return;
    if (e.target !== e.currentTarget) return; // Ignora cliques dentro do conteúdo
    if (onCancel) return onCancel();
    if (onConfirm) return onConfirm();
  };

  return (
    <div className={`modal-overlay ${className || ''}`} role="presentation" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h3 id={titleId}>{title}</h3>}
        <div className="modal-body">{body || <div className="modal-message">{message}</div>}</div>
        <div className="modal-actions">
          {cancelText && (
            <button className="button-secondary" onClick={onCancel}>{cancelText}</button>
          )}
          <button className="button-primary" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
